export const DEFAULT_ERROR_MESSAGE = 'That couldn’t be completed. Wait and try again.';
export const PAYMENT_SAVED_SUCCESS_MESSAGE = 'Payment method saved';
export const PAYMENT_UPDATED_SUCCESS_MESSAGE = 'Payment method updated';
export const PAYMENT_METHOD_UNPROCESSABLE_MESSAGE =
  'That payment method couldn’t be saved. Try a different payment method.';
export const PAYMENT_METHOD_INSUFFICIENT_FUNDS_MESSAGE =
  'Your payment method didn’t have enough balance to cover this payment. ' +
  'Add funds or use a different payment method.';
export const PAYMENT_METHOD_UPDATED_SUCCESS_MESSAGE = 'Payment method updated';
export const PAYMENT_SCHEDULED_SUCCESS_MESSAGE = 'Payment scheduled';
export const PAYMENT_SCHEDULED_MAYBE_LATE_MESSAGE = 'Payment scheduled. It’s likely to arrive after its payment date.';
export const PAYMENT_SCHEDULED_ALWAYS_LATE_MESSAGE = 'Payment scheduled. It’s likely to arrive after its payment date.';
export const PAYMENT_PAID_MESSAGE = 'Payment paid';
export const PAYMENT_PAID_OFFLINE_MESSAGE = 'Payment marked as paid offline';
export const PAYMENT_CANCEL_SUCCESS_MESSAGE = 'Scheduled payment canceled';
export const MICRODEPOSIT_SUCCESS_MESSAGE = 'Payment method verified';
export const MICRODEPOSIT_FAIL_MESSAGE = 'These amounts don’t match our records';
export const PAYMENT_TIMEOUT_MESSAGE =
  'This is taking longer than expected. ' + 'Check your dashboard to verify your payment status.';
export const ONE_TIME_PAYMENT_PAID_MESSAGE = 'One-time payment paid';
export const MOVE_IN_COSTS_SCHEDULED_MESSAGE = 'Move-in payment scheduled';
export const MOVE_IN_COSTS_PAID_MESSAGE = 'Move-in payment paid';
export const PAYMENT_UNPROCESSABLE_MESSAGE =
  'We couldn’t process your payment using that method. Contact your bank ' + 'or try a different payment method.';
export const PAST_DUE_WARNING_IF_PAYMENT_PLAN_AVAILABLE_MESSAGE =
  'Past due amount doesn’t reflect any payment plan installments you have made';
export const PAYMENT_REPORTING_OPT_IN_SUCCESS_MESSAGE = 'You’re enrolled in rent reporting';
export const PAYMENT_REPORTING_OPT_OUT_SUCCESS_MESSAGE = 'You are no longer enrolled in rent reporting';
export const PAYMENT_REPORTING_OPT_OUT_WARNING_MESSAGE =
  'If you opt out, your rent payments will no longer be shared with the credit bureaus. As a reminder, ' +
  'Zillow doesn’t report late or missed payments, but any on time payments ' +
  'made while enrolled in the program will be included as part of your credit history.\n\n' +
  'Please note that at this time we cannot support re-enrollment in this program once you have opted out.';
export const PAYMENT_REPORTING_OPT_IN_SUCCESS_MODAL_MESSAGE = `
    Congratulations on taking the first step towards building your credit.
    You can expect to see this reflected on your credit report within 30-45 days.
`;
export const CREDIT_TRACKING_UNENROLL_SUCCESS_MESSAGE = 'You are no longer enrolled in credit tracking';
export const CREDIT_TRACKING_UNENROLL_FAILURE_MESSAGE = 'You couldn’t be unenrolled from credit tracking. Try again.';
export const CREDIT_TRACKING_OPT_OUT_WARNING_MESSAGE =
  'If you opt out, you will no longer be able to see your credit score on Zillow.';
export const CREDIT_TRACKING_ENROLL_SUCCESS_MESSAGE = 'You are now enrolled in credit tracking';
export const CREDIT_TRACKING_ENROLL_FAILURE_MESSAGE = 'You couldn’t be enrolled in credit tracking. Try again.';
